import ymaps from '../../../../../node_modules/ymaps/dist/ymaps.esm';

export default new class ClientMap {
  constructor() {
    this.mapWrapperSelector = 'client__map-wrap';

    this.maxWidth = 280;

    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', async () => {
      this.map = await ymaps.load('https://api-maps.yandex.ru/2.1/?lang=ru_RU&coordorder=longlat');
      this.loadMap();
    });
  }

  loadMap() {
    this.map.ready(() => {
      this.initMap();
    });
  }

  initMap() {
    const app = document.querySelector(`.${this.mapWrapperSelector}`);
    try {
      const mapContainer = document.createElement('div');
      mapContainer.classList = 'client__map';
      app.append(mapContainer);

      const obMap = new this.map.Map(mapContainer, {
        controls: ['zoomControl', 'searchControl'],
        center: [91.442423, 53.720976],
        zoom: 4,
      });

      const objectManager = new this.map.ObjectManager({
        // Чтобы метки начали кластеризоваться, выставляем опцию.
        clusterize: true,
        // ObjectManager принимает те же опции, что и кластеризатор.
        gridSize: 32,
        clusterDisableClickZoom: true,
      });

      objectManager.objects.options.set('preset', 'islands#icon');
      objectManager.clusters.options.set('preset', 'islands#icon');
      obMap.geoObjects.add(objectManager);

      $.ajax({
        url: '/themes/theme291/assets/geojson/clients-map.geojson',
      })
        .done((data) => {
          objectManager.add(data);
        });
      obMap.behaviors.disable('scrollZoom');
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Something went wrong', error);
    }
  }
}();
